import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Tooltip } from 'reactstrap'

export default class BetterTooltip extends React.Component {
  static propTypes = {
    title: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      id: _.uniqueId('tooltip-'),
      shown: false,
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({
      shown: !this.state.shown,
    })
  }

  render() {
    const { id, shown } = this.state
    const { title, children } = this.props
    return (
      <React.Fragment>
        <span id={id}>{children}</span>
        {title && (
          <Tooltip
            isOpen={shown}
            target={id}
            {...this.props}
            toggle={this.toggle}
          >
            {title}
          </Tooltip>
        )}
      </React.Fragment>
    )
  }
}
